export default __webpack_public_path__ + "components/forecast-table-elevation/static/top-f14659b1bc196fa775e350a3aead3191.svg";